import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CellAlignmentEnum, ConfigColumn, NumberColumnPipe, TypeColumn } from '@eqproject/eqp-table';
import { TranslateService } from '@ngx-translate/core';
import { DocumentDTO } from '../../../../models/document.model';
import { ActorType, CDV_TRANSITIONS, CDVEventsDetailDTO, CDVPhaseCode, CDVStatusReasonMapDTO, DocumentCDVEvents } from '../../../../models/documentcdvevent.model';
import { CompanyDTO } from '../../../../models/company.model';
import { CompanyService } from '../../../../services/company.service';
import { GlobalService } from '../../../../services/global.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { UtilityService } from '../../../../services/utility.service';
import { LicenceService } from '../../../../services/licence.service';
import { DocumentCDVEventService  } from '../../../../services/documentcdvevent.service';
import { LookupDTO } from '../../../../models/lookup.model';
import { LookupService } from './../../../../services/lookup.service';
import { stat } from 'fs';
import * as uuid from 'uuid';
import { DocumentXMLService } from './../../../../services/documentXML.service';
import { DialogService } from './../../../../services/dialog.service';


@Component({
  selector: 'app-cdv-event',
  templateUrl: './cdv-event.component.html',
  styleUrls: ['./cdv-event.component.scss']  
})

export class CdvEventComponent implements OnInit {  
  idDocument: number;
  idPassiveDocument: number;
  currentCompany: CompanyDTO;
  documentcdvForm: UntypedFormGroup;     
  cdveventsDetail: CDVEventsDetailDTO;
  isPassiveDocument: boolean = false;
  retriviedStatusReasonCodes: Array<LookupDTO> = new Array<LookupDTO>();  
  retriviedCDVStatus: Array<LookupDTO> = new Array<LookupDTO>();  
  filteredCDVStatus: LookupDTO[] = [];
  StatusReasonColumns = [];
  CDVStatusColumns = [];
  lastStatusCode: number;
  lastStatusDescription: string;  
  retriviedStatusReasonMap: CDVStatusReasonMapDTO[];
  selectedCDVStatusId: string | number | null;
  selectedStatusReasonId: number | null = null;
  actorType: ActorType;
  

constructor(    
    public translate: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private companyService: CompanyService,
    private documentCDVService: DocumentCDVEventService,
    private documentXMLService: DocumentXMLService,
    private dialogRef: MatDialogRef<CdvEventComponent>,
    private lookupService: LookupService,
    private utilityService: UtilityService,
    private licenceService: LicenceService,
    @Inject(MAT_DIALOG_DATA) public data: any    
  ) { 
  
  
  }

  async ngOnInit() {
    this.createForm();
    this.dialogRef.disableClose = false;
    this.idDocument = this.data.idDocument;
    this.idPassiveDocument = this.data.idPassiveDocument;      
    this.isPassiveDocument = this.idPassiveDocument != null && this.idPassiveDocument != 0 ? true : false;  
    this.actorType = this.isPassiveDocument ? 'supplier' : 'buyer';
    this.currentCompany = await this.companyService.getCompanyByID(GlobalService.getUsedCompany());    
    this.getCDVeventsDetail();
    this.retriviedCDVStatus = await this.lookupService.GetLookupEntities('CDVStatus');    
    this.retriviedStatusReasonCodes = await this.documentCDVService.getCDVStatusReasonsAvailable(0);
        
        

    this.StatusReasonColumns = [
      { dataField: 'Code', caption: 'GENERIC_FIELDS.CODE', minWidth: 100 },
      { dataField: 'Description', caption: 'GENERIC_FIELDS.REASON', minWidth: 200 }
    ];

    this.CDVStatusColumns = [
      { dataField: 'FullObject.Code', caption: 'GENERIC_FIELDS.CODE', minWidth: 100 },
      { dataField: 'Label', caption: 'GENERIC_FIELDS.DESCRIPTION', minWidth: 200 }
    ];

  }

  getAllowedNextStatusCodes(lastStatusCode: number | null | undefined): number[] {
    if (lastStatusCode == null) {
      return null;
    }

    return CDV_TRANSITIONS[this.actorType]?.[lastStatusCode] ?? [];
  }

  filterCDVStatuses(retriviedCDVStatus: LookupDTO[],lastStatusCode: number | null | undefined  ): LookupDTO[] {    
    const allowedCodes = this.getAllowedNextStatusCodes(lastStatusCode);    
    // x il momento Sblocco
    return retriviedCDVStatus.filter(FullObject => allowedCodes.includes(Number(FullObject.FullObject.Code) ));
    //return retriviedCDVStatus;
    
  }

 async filterStatusReasonsByStatus(selectedCDVStatusId: number | number | null | undefined) {
  
  // per il momento non filtro
  this.selectedCDVStatusId = selectedCDVStatusId;
  return;
  if (!selectedCDVStatusId) {
    this.retriviedStatusReasonCodes = [];
    this.selectedStatusReasonId = null;
    return;
  }
  
  this.selectedStatusReasonId = null;  
    
  this.retriviedStatusReasonCodes =
    await this.documentCDVService.getCDVStatusReasonsAvailable(selectedCDVStatusId);
}
   createForm() {
      
    // this.documentcdvForm = this.formBuilder.group({
    //   servizio: [this.namirialPayLink.ServicePay == null? 0: this.namirialPayLink.ServicePay  , Validators.required]      
    // });
  }

  PhaseCodeToText(phasecode: any): string {
        
        let result: string = "";
        
        if (phasecode == null || phasecode == 0) {
          return result;
        }
            
        result = this.translate.instant("ENUMS.CDV_PHASE." + phasecode);              
        return result;
      }
  
   async sendToPA() {
      
    var self = this;
    
    if (!this.selectedCDVStatusId) {
      DialogService.Error(this.translate.instant("DIALOGS.CDV_STATUS_REQUIRED"));
      return;
    }

    let code =  this.retriviedCDVStatus.find(x => x.ID == this.selectedCDVStatusId).FullObject.Code;
    let des =  this.retriviedCDVStatus.find(x => x.ID == this.selectedCDVStatusId).FullObject.Description;

    let id = this.isPassiveDocument == false? this.idDocument : this.idPassiveDocument;
    
    DialogService.Confirm(this.translate.instant("DIALOGS.CDV_STATUS_CONFIRM",  { statuscode: code, statusdes: des }), () => {
      this.documentXMLService.sendXmlCDARToPA(id,  Number(this.selectedCDVStatusId), this.isPassiveDocument ).then(async (res) => {              
        DialogService.Success(self.translate.instant("DIALOGS.SEND_PA_SUCCESS"));                      
        this.getCDVeventsDetail();
        }).catch((err) => {
          
          DialogService.Error(err.message);          
        })            
        }, true);                        
        return false    
          
     
  }
   
  async getCDVeventsDetail() {
    this.cdveventsDetail = await this.documentCDVService.getdocumentCDVEvents(this.currentCompany.ID, this.isPassiveDocument == false? this.idDocument : this.idPassiveDocument, this.isPassiveDocument);                   
    
    if (this.cdveventsDetail.lastStatusCode != null) {
      this.lastStatusCode = this.cdveventsDetail.lastStatusCode;
      this.lastStatusDescription = this.cdveventsDetail.lastStatusCode.toString() + ' ' + this.cdveventsDetail.lastStatusDescription.toString();
    }
    this.filteredCDVStatus = this.filterCDVStatuses(this.retriviedCDVStatus,this.lastStatusCode);    
  }
   
  closeform() {      
      let isValid = false;
         
      this.dialogRef.close(isValid); // Chiusura del dialogo con il valore booleano
    }

}
